import { Injectable } from '@angular/core';
import { catchError, map, take } from 'rxjs/operators';
import { LoginService } from '../login/login.service';
import { LoginStorage } from '../login/login.storage';
import { environment } from '../../environments/environment';
import { forkJoin, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginParamsUtil {
  constructor(
    private readonly loginService: LoginService,
    private readonly loginStorage: LoginStorage,
  ) {}

  setLoginParams() {
    forkJoin({
      attempts: this.loginService.getSimulacaoTentativas().pipe(
        take(1),
        map((res) => res.value),
        catchError(() => of(environment.SIMULACAO_TENTATIVAS)),
      ),
      time: this.loginService.getSimulacaoTempo().pipe(
        take(1),
        map((res) => res.value),
        catchError(() => of(environment.SIMULACAO_TEMPO)),
      ),
      items: this.loginService.getItensPaginaHome().pipe(
        take(1),
        map((res) => res.value),
        catchError(() => of(environment.ITENS_PAGINA_HOME)),
      ),
    }).subscribe(({ attempts, time, items }) => {
        this.loginStorage.registerSimulacaoTentativas(attempts);
        this.loginStorage.registerSimulacaoTempo(time);
        this.loginStorage.registerItensPaginaHome(items);
      });
  }

  setOptions(options: string[] | null) {
    const optionsParams = options || [];
    this.loginStorage.registerOptions(optionsParams);
  }
}
